import { render, staticRenderFns } from "./CommonPreview.vue?vue&type=template&id=e770a874&scoped=true"
import script from "./CommonPreview.vue?vue&type=script&lang=js"
export * from "./CommonPreview.vue?vue&type=script&lang=js"
import style0 from "./CommonPreview.vue?vue&type=style&index=0&id=e770a874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e770a874",
  null
  
)

export default component.exports